import React, { FC } from 'react'

import cn from 'classnames'

import classes from './hamburger.module.scss'

interface HamburgerProps {
  open: boolean
  onClick: () => void
}

export const Hamburger: FC<HamburgerProps> = ({ open, onClick }) => {
  const menuTitle = open ? 'Close' : 'Menu'

  return (
    <button
      className={cn(classes.hamburgerWrapper, 'redesign-burger', {
        [classes.open]: open,
      })}
      onClick={onClick}
      data-testid="burger-menu"
      title={menuTitle}
    >
      <span className={classes.box}>
        <span className={cn(classes.inner, { [classes.open]: open })} />
      </span>
    </button>
  )
}

export default Hamburger
